import { FeatureLogger } from "../utils/feature-logger";

const name = "viz-analytics";

export const logger = new FeatureLogger(name);
